import type { ProductV2, SearchResultV2 } from "@openfoodfacts/openfoodfacts-nodejs";

export type ProductV3 = ProductV2 & {
  _id?: string;
  last_updated_t?: number;
  image_ingredients_url: string;
  image_ingredients_thumb_url: string;
  _keywords?: string[];
  nutriments: {
    "energy-kcal_100g"?: number;
    carbohydrates_100g?: number;
    fat_100g?: number;
    proteins_100g?: number;
    fiber_100g?: number;
  } & ProductV2["nutriments"];
  nutriscore_grade?: string;
  nova_group?: number;
  ecoscore_grade?: string;
};
export const LANGUAGE_CODES = [
  "en", // Try first based on % of translations on https://crowdin.com/project/openfoodfacts
  "de",
  "nl",
  "fr",
  "cz",
  "pt",
  "br",
  "uk",
  "id",
  "it",
  // The rest.
  "af",
  "ar",
  "az",
  "be",
  "bg",
  "bn",
  "bs",
  "ca",
  "cs",
  "cy",
  "da",
  "el",
  "es",
  "et",
  "eu",
  "fa",
  "fi",
  "ga",
  "gl",
  "gu",
  "he",
  "hi",
  "hr",
  "hu",
  "hy",
  "is",
  "ja",
  "ka",
  "kk",
  "km",
  "kn",
  "ko",
  "ky",
  "lb",
  "lo",
  "lt",
  "lv",
  "mk",
  "ml",
  "mn",
  "mr",
  "ms",
  "mt",
  "my",
  "nb",
  "ne",
  "nn",
  "pa",
  "pl",
  "ps",
  "ro",
  "ru",
  "sd",
  "si",
  "sk",
  "sl",
  "sq",
  "sr",
  "sv",
  "sw",
  "ta",
  "te",
  "th",
  "tl",
  "tr",
  "ur",
  "uz",
  "vi",
  "yi",
  "zh",
] as const;

export const getProductName = (product: ProductV3): string => {
  if (product.product_name) {
    return product.product_name;
  }
  for (const lang of LANGUAGE_CODES) {
    const key = `product_name_${lang}` as keyof ProductV3;
    if (product[key]) {
      return product[key] as string;
    }
  }
  return "";
};

export const getNutriscore = (product: ProductV3): string | undefined => {
  if (
    product.nutriscore_grade &&
    ["a+", "a", "b", "c", "d", "e"].includes(product.nutriscore_grade)
  ) {
    return product.nutriscore_grade;
  }
  return undefined;
};

export const getNovaScore = (product: ProductV3): string | undefined => {
  if (product.nova_group && product.nova_group >= 1 && product.nova_group <= 4) {
    return product.nova_group.toString();
  }
  return undefined;
};

export const getGreenscore = (product: ProductV3): string | undefined => {
  if (product.ecoscore_grade && ["a", "b", "c", "d", "e"].includes(product.ecoscore_grade)) {
    return product.ecoscore_grade;
  }
  return undefined;
};

export type SearchResultV3 = SearchResultV2 & {
  hits: ProductV3[];
};
